"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomBottomNavigation = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _reactDeviceDetect = require("react-device-detect");
var _mobileBottomNavigationStyles = _interopRequireDefault(require("../header/mobileBottomNavigationStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CustomBottomNavigation = _ref => {
  let {
    bottomItems
  } = _ref;
  const classes = (0, _mobileBottomNavigationStyles.default)();
  const [bottomButton, setBottomButton] = (0, _react.useState)(0);
  return /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, {
    value: bottomButton,
    showLabels: true,
    className: _reactDeviceDetect.isIOS13 || _reactDeviceDetect.isIOS ? classes.bottomIOS : classes.bottomWrapper
  }, bottomItems.map((item, index) => /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: item.label,
    icon: item.icon,
    onClick: () => {
      setBottomButton(index);
      item.onClick();
    },
    classes: {
      root: classes.bottomButtons
    }
  })));
};
exports.CustomBottomNavigation = CustomBottomNavigation;
CustomBottomNavigation.propTypes = {
  bottomItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired).isRequired
};
var _default = exports.default = CustomBottomNavigation;